import {filter, reduce} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {precisionCalculation} from 'shared/web';

import {DeliveryNoteItem} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

export function calculateTotalPrices(items: DeliveryNoteItem[]) {
  const activeItems = filter((item: DeliveryNoteItem) => item.isActive)(items);

  const withoutVat = reduce((acc, item: DeliveryNoteItem) => {
    if (isNotNil(item.totalPrice) && item.totalPrice > 0) {
      return precisionCalculation.add(acc, item.totalPrice);
    }
    return acc;
  }, 0)(activeItems);

  return {
    withoutVat,
  };
}
